/**
 * Format partner-group names for the consent intro copy (K-4).
 *
 * Mirrors the Django `format_group_names_display` helper: each name is wrapped in
 * guillemets with non-breaking spaces; multiple names are comma-separated with a
 * localized final conjunction ("et" / "and"). The joiner is passed in (from i18n)
 * rather than hard-coded so English doesn't render the French "et" — the one
 * intentional refinement over the Django helper, which always uses "et".
 */
export function formatGroupNames(names: string[], and: string): string {
  // \u00a0 is a non-breaking space, matching Django's guillemet formatting.
  const quoted = names.map((name) => `«\u00a0${name}\u00a0»`);
  if (quoted.length > 1) {
    return `${quoted.slice(0, -1).join(", ")} ${and} ${quoted[quoted.length - 1]}`;
  }
  return quoted[0] ?? "";
}
